import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
const ChangePassword = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;

     const [formData, setFormData] = useState({
          userId: "",
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
     });
     const navigate = useNavigate();

     const [message, setMessage] = useState("");



     useEffect(() => {
          const token = sessionStorage.getItem('token');
          if (!token) {
               navigate('/login');
               return;
          }
          // ✅ Load user_code from sessionStorage
          const userCode = sessionStorage.getItem("user_code");
          setFormData((prev) => ({ ...prev, userId: userCode || "" }));
     }, []);

     const handleChange = (e) => {
          setFormData({ ...formData, [e.target.name]: e.target.value });
     };

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!formData.oldPassword || !formData.newPassword || !formData.confirmPassword) {
               setMessage("⚠️ All fields are required");
               return;
          }

          if (formData.newPassword !== formData.confirmPassword) {
               setMessage("❌ New Password and Confirm Password do not match");
               return;
          }

          try {
               const response = await fetch(`${baseUrl}/changepassword`, {
                    method: "POST",
                    headers: {
                         "Content-Type": "application/json",
                         "Authorization": `Bearer ${sessionStorage.getItem("token")}`, // ✅ if token required
                    },
                    body: JSON.stringify({
                         emp_code: formData.userId,
                         oldPassword: formData.oldPassword,
                         newPassword: formData.newPassword,
                         confirmPassword: formData.confirmPassword,
                    }),
               });

               const data = await response.json();

               if (response.ok && data.status) {
                    setMessage("✅ Password changed successfully!");
                    setFormData({
                         ...formData,
                         oldPassword: "",
                         newPassword: "",
                         confirmPassword: "",
                    });
                    alert("Password changed successfully. Please log in again.");
                    sessionStorage.clear();
                    localStorage.clear();
                    navigate('/login');
               } else {
                    setMessage(`❌ ${data.message || "Failed to change password"}`);
               }
          } catch (error) {
               console.error("Error:", error);
               setMessage("❌ Something went wrong. Please try again.");
          }
     };

     return (
          <div
               style={{
                    maxWidth: "400px",
                    margin: "50px auto",
                    padding: "20px",
                    border: "1px solid #ddd",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    fontFamily: "Arial, sans-serif",
               }}
          >
               <h3 style={{ textAlign: "center", marginBottom: "20px" }}>Change Password</h3>

               <form onSubmit={handleSubmit}>
                    {/* User ID */}
                    <div style={{ marginBottom: "15px" }}>
                         <label style={{ display: "block", marginBottom: "5px" }}>User ID</label>
                         <input
                              type="text"
                              name="userId"
                              value={formData.userId}
                              disabled
                              style={{
                                   width: "100%",
                                   padding: "10px",
                                   borderRadius: "5px",
                                   border: "1px solid #ccc",
                                   backgroundColor: "#f5f5f5",
                                   cursor: "not-allowed",
                              }}
                         />
                    </div>

                    {/* Old Password */}
                    <div style={{ marginBottom: "15px" }}>
                         <label style={{ display: "block", marginBottom: "5px" }}>Old Password</label>
                         <input
                              type="password"
                              name="oldPassword"
                              value={formData.oldPassword}
                              onChange={handleChange}
                              style={{
                                   width: "100%",
                                   padding: "10px",
                                   borderRadius: "5px",
                                   border: "1px solid #ccc",
                              }}
                         />
                    </div>

                    {/* New Password */}
                    <div style={{ marginBottom: "15px" }}>
                         <label style={{ display: "block", marginBottom: "5px" }}>New Password</label>
                         <input
                              type="password"
                              name="newPassword"
                              value={formData.newPassword}
                              onChange={handleChange}
                              style={{
                                   width: "100%",
                                   padding: "10px",
                                   borderRadius: "5px",
                                   border: "1px solid #ccc",
                              }}
                         />
                    </div>

                    {/* Confirm Password */}
                    <div style={{ marginBottom: "20px" }}>
                         <label style={{ display: "block", marginBottom: "5px" }}>Confirm Password</label>
                         <input
                              type="password"
                              name="confirmPassword"
                              value={formData.confirmPassword}
                              onChange={handleChange}
                              style={{
                                   width: "100%",
                                   padding: "10px",
                                   borderRadius: "5px",
                                   border: "1px solid #ccc",
                              }}
                         />
                    </div>

                    {/* Submit Button */}
                    <button
                         type="submit"
                         style={{
                              width: "100%",
                              padding: "12px",
                              backgroundColor: "#007bff",
                              color: "#fff",
                              border: "none",
                              borderRadius: "5px",
                              cursor: "pointer",
                              fontSize: "16px",
                         }}
                    >
                         Change Password
                    </button>
               </form>

               {message && (
                    <p
                         style={{
                              marginTop: "15px",
                              textAlign: "center",
                              color: message.includes("❌") || message.includes("⚠️") ? "red" : "green",
                         }}
                    >
                         {message}
                    </p>
               )}
          </div>
     );
};

export default ChangePassword;
